import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {Hort360PropertySummary} from '../../../../functions/src/types';
import {PropertyService} from '../../services/property.service';

@Component({
  selector: 'app-grower-recent',
  templateUrl: './grower-recent.component.html',
  styleUrls: ['./grower-recent.component.scss']
})
export class GrowerRecentComponent implements OnInit {
  @Output() selected = new EventEmitter<Hort360PropertySummary>();
  @Input() public highlighted: Hort360PropertySummary[] = [];
  @Input() public limit = 99999;
  @Input() class = '';
  public primaryColor = '#5eff00';

  constructor(
    public propertyService: PropertyService
  ) {
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
    this.primaryColor = primaryColor ?? this.primaryColor;
  }

  isHighlighted(property: Hort360PropertySummary) {
    return !this.highlighted || !!this.highlighted.find(p => p.id === property.id);
  }

  selectProperty(property: Hort360PropertySummary) {
    this.selected.emit(property);
  }

  ngOnInit(): void {}

}
